import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { Box, TextField, Pagination } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography, Divider } from '@mui/material';
import TableComponent from '../../ui/Table';
import LinearProgress from '@mui/material/LinearProgress';

export default function DetailsDialog({ open, onClose, title, data, tableHead }) {

  const [query, setQuery] = useState('');
  const [page, setPage] = useState(1);
  const rowsPerPage = 8;

  const filtered = data.filter((item) =>
    query.trim() === ''
      ? true
      : item.label.toLowerCase().includes(query.toLowerCase())
  ).sort((a, b) => b.count - a.count);

  const foundDescription = data.find((item) => item.description)

  const pageCount = Math.ceil(filtered.length / rowsPerPage);

  const displayedRows = filtered.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const calculateTotalCount = data.reduce((acc, cur) => acc + cur.count, 0);
  const calculateTotalCost = data.reduce((acc, cur) => acc + parseFloat(cur.cost), 0);

  useEffect(() => {
    setPage(1);
  }, [open, query]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={false}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: 3,
            height: '100vh',
            width: '60vw',
            display: 'flex',
            flexDirection: 'column'
          }
        }}
      >
        <DialogTitle sx={{ pb: 0, textAlign: 'center' }}>
          {title}
        </DialogTitle>

        <DialogContent sx={{overflow: 'hidden'}}>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 1 }}>
            <Box sx={{ display: 'flex', backgroundColor: '#F3F4F4', borderRadius: 2, px: 3, py: 1 }}>
              <Box>
                <Typography sx={{ fontSize: '15px', fontWeight: '600', color: 'text.secondary' }}>
                  Total Items: {filtered.length}
                </Typography>
              </Box>

              <Divider orientation="vertical" flexItem sx={{ mx: 2, backgroundColor: 'black' }} />

              <Box>
                <Typography sx={{ fontSize: '15px', fontWeight: '600', color: 'text.secondary' }}>
                  Total Count: {calculateTotalCount}
                </Typography>
              </Box>

              <Divider orientation="vertical" flexItem sx={{ mx: 2, backgroundColor: 'black' }} />

              <Box>
                <Typography sx={{ fontSize: '15px', fontWeight: '600', color: 'text.secondary' }}>
                  Total Cost: ${calculateTotalCost.toFixed(2)}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box sx={{ mt: 1 }}>
            <TextField
              fullWidth
              size="small"
              placeholder={`Search by ${tableHead[0]}`}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </Box>

          <Box sx={{ mt: 1 }}>
            <TableComponent
              tableHead={tableHead}
              tableBody={displayedRows.map((row) => {
                const percent = (row.count / calculateTotalCount) * 100;

                return {
                  label: row.label,
                  description: row.description,
                  count: row.count,
                  cost: row.cost,
                  share: (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box sx={{ flexGrow: 1 }}>
                        <LinearProgress
                          variant="determinate"
                          value={Math.min(100, percent)}
                          sx={{ height: 6, borderRadius: 999 }}
                        />
                      </Box>
                      <Box sx={{ width: 50 }}>
                        <Typography variant="caption" sx={{ fontWeight: 600 }}>
                          %<span style={{ fontFamily: 'Outfit' }}>{percent.toFixed(2)}</span>
                        </Typography>
                      </Box>
                    </Box>
                  ),
                };
              })}
              bodyCells={['label', ...(foundDescription ? ['description'] : []), 'count', 'cost', 'share']}
              bodyCellsCustomSymbol={{ cost: '$' }}
              customStyle={{
                tableContainer: {
                  height: '350px',
                  overflowY: 'scroll',
                },
                headerTableCell: (cell) => {
                  return ({
                    textAlign: "center",
                    border: '1px solid #d9d9d9',
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#000000c7",
                    backgroundColor: "#F5F5F5",
                    p: 0.8,
                    width: cell === 'Count' ? '18%'
                    : cell === 'ICD Code' ? '18%'
                    : cell === 'CPT Code' ? '18%'
                    : cell === 'Cost' ? '18%'
                    : cell === 'Share' ? '18%'
                     : 'auto'
                  })
                },
                tableCell: {
                  textAlign: "center",
                  border: '1px solid #d9d9d9',
                  p: 0.8,
                  fontWeight: "500",
                  verticalAlign: "middle",
                },
              }}
            />
          </Box>

        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
            {pageCount > 1 && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1, mb: 2 }}>
                <Pagination
                  count={pageCount}
                  page={page}
                  onChange={handlePageChange}
                  color="primary"
                />
              </Box>
            )}
            <Box sx={{ width: '25%' }}>
              <Button
                onClick={onClose}
                autoFocus
                sx={{
                  backgroundColor: 'primary.main',
                  color: 'white',

                  '&:hover': { backgroundColor: 'primary.dark' }
                }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}